export const getUserSocketNotification = (notification: any) => {
  if (
    notification?.talent_id ||
    notification?.gtp_id ||
    notification?.business_id
  )
    return null;

  return notification;
};

export const getTalentSocketNotification = (
  notification: any,
  talentId: string,
) => {
  if (notification?.talent_id?.toString() !== talentId?.toString()) return null;
  // if (
  //   notification.notification_type ===
  //     SocketNotificationType.AdminNotification ||
  //   notification.notification_type === SocketNotificationType.BookingInvite ||
  //   notification.notification_type === SocketNotificationType.BookingStart ||
  //   notification.notification_type === SocketNotificationType.GTPMemberInvite ||
  //   notification.notification_type === SocketNotificationType.GTPCardCreated ||
  //   notification.notification_type === SocketNotificationType.BookingCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.GTPBookingCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.CoffeeCallCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.CloverTicketPurchased ||
  //   notification.notification_type === SocketNotificationType.GTPMemberInvite ||
  //   notification.notification_type ===
  //     SocketNotificationType.DiamondProductPurchased ||
  //   notification.notification_type ===
  //     SocketNotificationType.CardQuestionCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.CardAnswerCreated
  // )
  return notification;

  // return null;
};

export const getBusinessSocketNotification = (
  notification: any,
  businessId: number,
) => {
  if (notification?.business_id?.toString() !== businessId?.toString())
    return null;
  // if (
  //   notification.notification_type ===
  //     SocketNotificationType.AdminNotification ||
  //   notification.notification_type === SocketNotificationType.BookingInvite ||
  //   notification.notification_type === SocketNotificationType.BookingStart ||
  //   notification.notification_type === SocketNotificationType.GTPMemberInvite ||
  //   notification.notification_type === SocketNotificationType.GTPCardCreated ||
  //   notification.notification_type === SocketNotificationType.BookingCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.GTPBookingCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.CoffeeCallCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.CloverTicketPurchased ||
  //   notification.notification_type === SocketNotificationType.GTPMemberInvite ||
  //   notification.notification_type ===
  //     SocketNotificationType.DiamondProductPurchased ||
  //   notification.notification_type ===
  //     SocketNotificationType.CardQuestionCreated ||
  //   notification.notification_type ===
  //     SocketNotificationType.CardAnswerCreated
  // )
  return notification;

  // return null;
};

export const getGTPUserSocketNotification = (
  notification: any,
  gtpUserId: string,
) => {
  if (notification?.gtp_id?.toString() !== gtpUserId?.toString()) return null;
  // if (
  //   notification.notification_type ===
  //     SocketNotificationType.AdminNotification ||
  //   notification.notification_type === SocketNotificationType.BookingInvite ||
  //   notification.notification_type === SocketNotificationType.BookingStart ||
  //   notification.notification_type === SocketNotificationType.GTPMemberInvite ||
  //   notification.notification_type === SocketNotificationType.GTPCardCreated ||
  //   notification.notification_type === SocketNotificationType.BookingCreated ||
  //   notification.notification_type === SocketNotificationType.GTPBookingCreated ||
  //   notification.notification_type === SocketNotificationType.CoffeeCallCreated ||
  //   notification.notification_type === SocketNotificationType.CloverTicketPurchased
  // )
  return notification;

  // return null;
};
